import React from "react";
import { useHistory } from "react-router-dom";
import RenderIcons from "../../Assets/css/_icons/partner_icon/RenderIcons";

interface IProps {
    title: string;
    name: string;
    data: number;
    profileName: string;
    rangeHigh: number;
    rangeLow: number;
    tooltip: string;
    hasCTAButton: boolean;
}

const ResultChart: React.FunctionComponent<IProps> = (props) => {
    const history = useHistory();

    return (
        <React.Fragment>
            <div className="personality-trait">
                <h4 className="content-title" id={"title-" + props.name}>
                    {props.title}
                    <span className="tooltip-container" tabIndex={0}>
                        <RenderIcons iconName="info-circle" />
                        <span className="tooltip-text">{props.tooltip}</span>
                    </span>
                </h4>

                <div className="sr-only" aria-labelledby={"title-" + props.name}>
                    <p>
                        You're {props.title} score is <span id={props.name + "-score"}>{props.data}</span>.
                    </p>
                    <p className="profile-range">
                        The average score range for <span id={props.name + "-profile"}>{props.profileName}</span> is between{" "}
                        <span id={props.name + "-range-low"}>45</span> and <span id={props.name + "-range-high"}>72</span>
                    </p>
                </div>

                <div className={props.hasCTAButton ? "personality-trait-chart-container has-cta-button" : "personality-trait-chart-container"}>
                    <div className="personality-trait-chart-base">
                        <div className="personality-trait-chart-value" style={{ left: props.data + "%" }} data-score={props.data}></div>
                        <div
                            className="personality-trait-chart-profile-range profile-benchmark"
                            style={{ left: props.rangeLow + "%", right: 100 - props.rangeHigh + "%" }}
                            title={props.title + " Range: Low (" + props.rangeLow + "), High (" + props.rangeHigh + ")"}
                        ></div>
                    </div>
                    <div className="personality-trait-chart-label-left">Low</div>
                    <div className="personality-trait-chart-label-right">High</div>
                </div>

                {props.hasCTAButton && (
                    <div className="personality-trait-button" title="View Report for Conscientiousness">
                        <button
                            type="button"
                            className="btn-default btn-primary-outline btn-no-border btn-personality-trait-cta"
                            title={"View Detailed Report for " + props.title}
                            onClick={() => {
                                history.push("my-reputation/" + props.name);
                            }}
                        >
                            <span className="btn-icon">
                                <em className="las la-angle-right"></em>
                            </span>
                            <span className="btn-text sr-only">View Detailed Report for {props.title}</span>
                        </button>
                    </div>
                )}
            </div>
        </React.Fragment>
    );
};
export default ResultChart;
